module.exports = __webpack_public_path__ + "img/volunteer.46a8e473.png";